var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionSandClock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_action_sand_clock"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38 4V8H36V11.8756C36 15.0428 34.7554 18.004 32.6477 20.1957C31.6964 21.1849 30.5693 22.0173 29.3015 22.6412L31.4963 24.3971C31.8803 24.7042 32.2425 25.0326 32.582 25.3799C34.7598 27.6079 36 30.6137 36 33.7675V40H38V44H10V40H12V33.7675C12 30.6137 13.2402 27.6079 15.418 25.3799C15.7575 25.0326 16.1197 24.7042 16.5037 24.3971L18.6985 22.6412C17.4307 22.0173 16.3036 21.1849 15.3523 20.1957C13.2446 18.004 12 15.0428 12 11.8756V8H10V4H38ZM16 8V11.8756C16 14.9395 17.7477 17.7153 20.4645 19.0522L22 19.8077V25.1225L19.0024 27.5205C17.1047 29.0387 16 31.3372 16 33.7675V40H32V33.7675C32 31.3372 30.8953 29.0387 28.9976 27.5205L26 25.1225V19.8077L27.5355 19.0522C30.2523 17.7153 32 14.9395 32 11.8756V8H16Z",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 121 (Stroke) (Stroke)",
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 10V11.8756C18 14.9274 20.8994 18 24 18C27.1006 18 30 14.9274 30 11.8756V10H18Z",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 121 (Stroke) (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 38V34.1244C18 30.9901 20.792 28 24 28C27.208 28 30 30.9901 30 34.1244V38H18Z",
    fill: "#727272"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionSandClock);
export default __webpack_public_path__ + "static/media/ic_action_sand_clock.169529a57cb199b0930d2f7785397e3f.svg";
export { ForwardRef as ReactComponent };